
export class EmploymentTypeDto {
    empTypeId?: number;
    employmentType: string;
    status: boolean;
    createdAt : Date | any;
    createdUser : number;
    updatedAt : Date | any;
    updatedUser : number;
    versionFlag : number;


}

export const EmploymentTypeDtoDefault : EmploymentTypeDto = {
    empTypeId: 0,
    employmentType: "",
    status: true,
    createdAt : new Date() ,
    createdUser : 0,
    updatedAt : new Date() ,
    updatedUser : 0,
    versionFlag : 1

};

